import React from "react";
import { useParams } from "react-router";

import analytics from "fond/analytics";
import useEntityViews from "fond/hooks/useEntityViews";
import { PageContent } from "fond/widgets";
import SkeletonLoadingGrid from "fond/widgets/SkeletonLoadingGrid";

import { DEFAULT_REPORT_LOADING_SKELETON, Page } from "../constants";
import { usePollReportStatusHandle, useReportData } from "../hooks";
import ReportNavigation from "../Navigation";
import { reportWindowTitle } from "../util";

import ReportCostPageContent from "./ReportCostPageContent";

const ReportPage: React.FC = () => {
  useEntityViews();
  const { reportId } = useParams<"reportId">();

  const { report, isLoading } = useReportData(reportId);
  usePollReportStatusHandle(report);

  if (reportId) {
    analytics.track("Report.Cost.Cost Viewed", { reportId });
  }

  return (
    <PageContent
      windowTitle={reportWindowTitle("Cost", report?.Name)}
      title="Cost"
      mainContent={!isLoading && report ? <ReportCostPageContent report={report} /> : <SkeletonLoadingGrid items={DEFAULT_REPORT_LOADING_SKELETON} />}
      navigation={<ReportNavigation page={Page.COST} />}
      testId="report-cost-page"
    />
  );
};

export default ReportPage;
